

import React, { useRef, useState } from "react";
import hardik_pic from "../images/hardik_pic.jpg";
import har_img from "../images/har_img.jpg";
import third_1 from "../images/3rd_1.png";
import third_2 from "../images/3rd_2.png";
import third_3 from "../images/3rd_3.png";
import third_4 from "../images/3rd_4.png";
import sec_1 from "../images/second_1.png";
import sec_2 from "../images/second_2.png";
import sec_3 from "../images/second_3.png";
import for_1 from "../images/for_1.png";
import for_2 from "../images/for_2.png";
import for_3 from "../images/for_3.png";
import fif_1 from "../images/fif_1.png";
import fif_2 from "../images/fif_2.png";
import fif_3 from "../images/fif_3.png";
import fif_4 from "../images/fif_4.png";
import six_1 from "../images/six_1.png";
import six_2 from "../images/six_2.png";
import six_3 from "../images/six_3.png";
import six_4 from "../images/six_4.png";
import six_5 from "../images/six_5.png";
import sev_1 from "../images/sev_1.png";
import sev_2 from "../images/sev_2.png";
import sev_3 from "../images/sev_3.png";
import eig_1 from "../images/eigg_1.png";
import eig_2 from "../images/eigg_2.png";
import eig_3 from "../images/eigg_3.png";

// 🔹 TiltCard Component
function TiltCard({ img, title, description, onClick }) {
  const cardRef = useRef(null);
  const shineRef = useRef(null);
  const rafId = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    const shine = shineRef.current;
    const rect = card.getBoundingClientRect();

    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    const rotateX = (y - 0.5) * -35;
    const rotateY = (x - 0.5) * 35;

    const shineX = x * 100;
    const shineY = y * 100;

    if (rafId.current) cancelAnimationFrame(rafId.current);
    rafId.current = requestAnimationFrame(() => {
      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      shine.style.background = `radial-gradient(circle at ${shineX}% ${shineY}%, rgba(255,255,255,0.3), transparent 70%)`;
    });
  };

  const reset = () => {
    if (rafId.current) cancelAnimationFrame(rafId.current);
    const card = cardRef.current;
    const shine = shineRef.current;
    card.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg)";
    shine.style.background = "none";
  };

  return (
    <div
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={reset}
      onClick={onClick}
      className="
        relative rounded-xl overflow-hidden cursor-pointer
        transform-gpu transition-transform duration-300 ease-out
        will-change-transform bg-black/30 group hover:border-[2px] hover:border-white
        hover:shadow-[0_0_40px_1px_rgba(255,255,255,0.25)]
      "
      style={{ transformStyle: "preserve-3d" }}
    >
      <div className="absolute inset-[5px] rounded-lg border border-gray-400 pointer-events-none z-20" />

      <img
        src={img}
        alt={title}
        className="
          w-full 
          h-72 sm:h-80 md:h-96   
          object-cover pointer-events-none select-none z-10 relative
          opacity-60 transform transition-all duration-700 ease-out
          group-hover:opacity-100 group-hover:scale-110
        "
      />

      <div
        ref={shineRef}
        className="absolute inset-0 pointer-events-none transition-all duration-300 z-25"
        style={{ mixBlendMode: "soft-light" }}
      />

      <div className="absolute bottom-[-30px] left-3 sm:left-4 text-white drop-shadow-lg z-30">
        <div className="flex flex-col transition-transform duration-500 group-hover:-translate-y-10">
          <p className="text-xl sm:text-2xl font-bold">{title}</p>
          <p className="text-sm sm:text-lg opacity-0 group-hover:opacity-90 transition-opacity duration-300 mt-1">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}

// 🔹 Full-Screen Image Viewer Component
function ImageViewer({ images, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const isMobile = window.innerWidth < 768;

  const touchStartX = useRef(0);
const touchEndX = useRef(0);

const handleTouchStart = (e) => {
  touchStartX.current = e.touches[0].clientX;
};

const handleTouchMove = (e) => {
  touchEndX.current = e.touches[0].clientX;
};

const handleTouchEnd = () => {
  const diff = touchStartX.current - touchEndX.current;

  if (diff > 50) {
    // swipe left → next
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  } else if (diff < -50) {
    // swipe right → previous
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  }
};


  React.useEffect(() => {
    const timer = setTimeout(() => setIsZoomed(true), 10);
    return () => clearTimeout(timer);
  }, []);

  React.useEffect(() => {
  if (isMobile) return; // ❌ mobile pe keyboard disable

  const handleKeyDown = (e) => {
    if (e.key === "ArrowLeft") {
      setCurrentIndex((prev) =>
        prev === 0 ? images.length - 1 : prev - 1
      );
    } else if (e.key === "ArrowRight") {
      setCurrentIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    } else if (e.key === "Escape") {
      onClose();
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}, [images, onClose, isMobile]);


  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-90 flex flex-col justify-center items-center z-50 cursor-pointer p-4"
      onClick={onClose}
    >
     <img
  src={images[currentIndex]}
  alt="Full screen view"

  // ✅ ADD THESE (only mobile)
  onTouchStart={isMobile ? handleTouchStart : undefined}
  onTouchMove={isMobile ? handleTouchMove : undefined}
  onTouchEnd={isMobile ? handleTouchEnd : undefined}

  className={`
    max-h-[70vh] sm:max-h-[85vh] 
    max-w-[95vw] sm:max-w-[90vw]
    object-contain rounded-xl
    border-[2px] border-white
    shadow-[0_0_20px_8px_rgba(255,255,255,0.30)]
    transform transition-transform duration-500 ease-out
    ${isZoomed ? "scale-100" : "scale-75"} 
  `}
/>


      <p
  className="
    text-white text-sm sm:text-lg select-none px-3 py-1
    rounded-md bg-gradient-to-r from-cyan-500/60 via-black/40 to-blue-400/50
    backdrop-blur-sm mt-4
  "
>
  {isMobile
    ? "Swipe left or right to navigate"
    : "Use ← and → keys to navigate"}
</p>

    </div>
  );
}

// 🔹 Main Gallery Page
export default function Gallery() {
  const [selectedCardImages, setSelectedCardImages] = useState(null);

  const cards = [
    {
      images: [hardik_pic, har_img, "/images/hardik3.jpg"],
      title: "Myself",
      description: "Candid frames of thought, mood, and soul",
    },
    {
      images: [sec_1, sec_2, sec_3],
      title: "Tide Trails",
      description: "Footprints fade, but memories stay with tidas",
    },
    {
      images: [third_1, third_2, third_3, third_4],
      title: "Wings in Motion",
      description: "Graceful wings soaring through nature's canvas",
    },
    {
      images: [for_1, for_2, for_3],
      title: "Spiritual Moments",
      description: "Frames of Faith, Devotion, and inner Peace",
    },
    {
      images: [fif_1, fif_2, fif_3, fif_4],
      title: "Flora & Peace",
      description: "Nature's poetry written in petals and green",
    },
    {
      images: [six_1, six_2, six_3, six_4, six_5],
      title: "Bites & Plates",
      description: "Where cravings meet creativity on every plate",
    },
    {
      images: [sev_1, sev_2, sev_3],
      title: "After Dark",
      description: "Moonlit thoughts painted on a dark canvas",
    },
    {
      images: [eig_1, eig_2, eig_3],
      title: "About Us",
      description: "Chasing clouds like they owe me something",
    },
  ];

  return (
    <div>
      <h1 className="text-[28px] sm:text-[45px] font-semibold mt-[-20px] sm:mt-[-70px] mb-15 md:mb-0 ">
        Career Snapshot
      </h1>
      <hr className="h-[4px] sm:h-[5px] bg-cyan-300 border-0 mt-3 w-[80px] sm:w-[100px] mb-8" />

      <div className="px-2 sm:px-6 md:px-12">

        <div
          className="
            flex flex-wrap justify-center 
            gap-6 sm:gap-8 
            px-2 sm:px-6 md:px-12
          "
        >
          {cards.map((c) => (
            <div
              key={c.title}
              className="
                w-full                   
                sm:w-[48%]              
                lg:w-[30%]              
                flex justify-center     
              "
            >
              <TiltCard
                img={c.images[0]}
                title={c.title}
                description={c.description}
                onClick={() => setSelectedCardImages(c.images)}
              />
            </div>
          ))}
        </div>
      </div>

      {selectedCardImages && (
        <ImageViewer
          images={selectedCardImages}
          onClose={() => setSelectedCardImages(null)}
        />
      )}
    </div>
  );
}

